import emptyApi from '@epi-api/emptyApi';
import config from '@epi-config';
import { get, post } from '@epi-helpers/FetchHelpers';
import { DepositsResponse } from '@epi-models/pages/Reports';
import { TRANSACTIONS_PAGE_SIZE } from '@epi-api/constants';

export const getDepositsRequest = async (
  page: number,
  from: string,
  to: string,
  abortController: AbortController | null = null
): Promise<{ data?: DepositsResponse; error?: any }> => {
  try {
    const response: DepositsResponse | undefined = await get(
      `${config.apiHost}/api/deposits/summary/${page}?filterStartDate=${from}&filterEndDate=${to}&pageSize=${TRANSACTIONS_PAGE_SIZE}`,
      undefined,
      undefined,
      abortController?.signal
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

const syncDepositRequest = async (
  paymentId: string
): Promise<{ data: void } | { error: any }> => {
  try {
    await post(
      `${config.apiHost}/api/deposit-orders/payment/${paymentId}/sync`,
      undefined
    );
    return { data: undefined };
  } catch (e) {
    return { error: e };
  }
};

export const depositsApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getDeposits: build.query<
      DepositsResponse,
      {
        page: number;
        from: string;
        to: string;
        abortController: AbortController | null;
      }
    >({
      queryFn: ({ page, from, to, abortController }) =>
        getDepositsRequest(page, from, to, abortController),
      keepUnusedDataFor: 0
    }),
    syncDeposit: build.mutation<void, string>({
      queryFn: (paymentId: string) => syncDepositRequest(paymentId)
    })
  })
});

export const {
  useGetDepositsQuery,
  useLazyGetDepositsQuery,
  useSyncDepositMutation
} = depositsApi;
